import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, DialogProps } from '@mui/material';

type AppDialogProps = {
  open: boolean;
  onClose: () => void;
  title: React.ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  actions?: React.ReactNode;
  children: React.ReactNode;
  dialogProps?: Omit<DialogProps, 'open' | 'onClose'>;
};

export function AppDialog({
  open,
  onClose,
  title,
  maxWidth = 'sm',
  fullWidth = true,
  actions,
  children,
  dialogProps,
}: AppDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth={fullWidth} {...dialogProps}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      {actions ? <DialogActions>{actions}</DialogActions> : null}
    </Dialog>
  );
}
